import { useEffect, useState } from 'react';

import type { Rect } from '../types';

export default function useTargetRect(
  selector: string | undefined,
): Rect | undefined {
  const [rect, setRect] = useState<Rect>();

  useEffect(() => {
    if (!selector) {
      setRect(undefined);

      return;
    }

    const update = () => {
      const el = document.querySelector(selector);
      if (!el) return;

      const r = el.getBoundingClientRect();
      setRect({ top: r.top, left: r.left, width: r.width, height: r.height });
    };

    update();

    window.addEventListener('resize', update);

    return () => window.removeEventListener('resize', update);
  }, [selector]);

  return rect ?? { top: 0, left: 0, width: 0, height: 0 };
}
